// extracted by mini-css-extract-plugin
module.exports = {"redirectPage":"RedirectPage_redirectPage__y5L9h","loader":"RedirectPage_loader__KTwho"};